import { Popover } from './src/Popover';
import { PopoverBody } from './src/PopoverBody';
import { PopoverText } from './src/PopoverText';
import { PopoverTitle } from './src/PopoverTitle';
import { PopoverAction } from './src/PopoverAction';
import { PopoverClose } from './src/PopoverClose';
import { Trigger } from './src/Trigger';

Popover.Body = PopoverBody;
Popover.Title = PopoverTitle;
Popover.Text = PopoverText;
Popover.Action = PopoverAction;
Popover.Close = PopoverClose;
Popover.Trigger = Trigger;

export { Popover };
